var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiggy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.5365C30 19.6405 28.904 21.8165 27.78 23.2165C27.2655 23.8604 26.6668 24.4322 26 24.9165V27.0005C26 27.7962 25.6839 28.5593 25.1213 29.1219C24.5587 29.6845 23.7956 30.0005 23 30.0005H22C21.4696 30.0005 20.9609 29.7898 20.5858 29.4148C20.2107 29.0397 20 28.531 20 28.0005H16C16 28.531 15.7893 29.0397 15.4142 29.4148C15.0391 29.7898 14.5304 30.0005 14 30.0005H13C12.2044 30.0005 11.4413 29.6845 10.8787 29.1219C10.3161 28.5593 10 27.7962 10 27.0005V26.5725C7.274 25.7066 5.376 23.5046 4.44 20.8566C4.4008 20.7272 4.33166 20.6089 4.23818 20.5112C4.14471 20.4136 4.02953 20.3394 3.902 20.2945C3.35508 20.1387 2.87371 19.8091 2.53059 19.3556C2.18748 18.9021 2.00124 18.3492 2 17.7806V16.1925C2 15.0405 2.764 14.0285 3.87 13.7125C4.078 13.6525 4.302 13.4525 4.412 13.1185C5.104 11.0265 6.55 9.49855 8.412 8.37855C8.60533 8.26122 8.77867 8.16122 8.932 8.07855V4.32655C8.93318 4.02257 9.02547 3.72593 9.19695 3.47494C9.36844 3.22395 9.61124 3.03014 9.894 2.91855C10.1689 2.80334 10.4712 2.77036 10.7645 2.82361C11.0577 2.87686 11.3292 3.01405 11.546 3.21855C12.052 3.69855 12.716 4.26855 13.426 4.73455C14.156 5.21055 14.84 5.51455 15.398 5.57055H15.408C22.154 5.56855 30 8.94255 30 16.5365Z",
    fill: "url(#paint0_radial_5099_13485)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5C11 13.8978 10.842 14.2794 10.5607 14.5607C10.2794 14.842 9.89782 15 9.5 15C9.10218 15 8.72064 14.842 8.43934 14.5607C8.15804 14.2794 8 13.8978 8 13.5C8 13.1022 8.15804 12.7206 8.43934 12.4393C8.72064 12.158 9.10218 12 9.5 12C9.89782 12 10.2794 12.158 10.5607 12.4393C10.842 12.7206 11 13.1022 11 13.5Z",
    fill: "url(#paint1_radial_5099_13485)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.884 9.45398C14.0531 9.04487 14.3777 8.71964 14.7865 8.54975C15.1952 8.37986 15.6547 8.37923 16.064 8.54798L27.184 13.138C27.5935 13.3069 27.9191 13.6316 28.0892 14.0406C28.2593 14.4497 28.2599 14.9095 28.091 15.319C27.9221 15.7285 27.5974 16.0541 27.1883 16.2242C26.7793 16.3943 26.3195 16.3949 25.91 16.226L14.79 11.634C14.3809 11.4649 14.0557 11.1403 13.8858 10.7315C13.7159 10.3227 13.7152 9.86323 13.884 9.45398Z",
    fill: "#9F1459"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.28 15.5518C25.3795 15.1 26.32 14.3318 26.9823 13.3447C27.6445 12.3576 27.9987 11.196 27.9997 10.0073C28.0008 8.81859 27.6487 7.65637 26.9882 6.66807C26.3277 5.67977 25.3886 4.90993 24.2899 4.45621C23.1912 4.0025 21.9825 3.88536 20.8171 4.11966C19.6517 4.35397 18.5822 4.92914 17.7442 5.77223C16.9062 6.61531 16.3376 7.68831 16.1103 8.85509C15.8831 10.0219 16.0076 11.2298 16.468 12.3258L24.28 15.5518Z",
    fill: "url(#paint2_linear_5099_13485)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.28 15.5518C25.3795 15.1 26.32 14.3318 26.9823 13.3447C27.6445 12.3576 27.9987 11.196 27.9997 10.0073C28.0008 8.81859 27.6487 7.65637 26.9882 6.66807C26.3277 5.67977 25.3886 4.90993 24.2899 4.45621C23.1912 4.0025 21.9825 3.88536 20.8171 4.11966C19.6517 4.35397 18.5822 4.92914 17.7442 5.77223C16.9062 6.61531 16.3376 7.68831 16.1103 8.85509C15.8831 10.0219 16.0076 11.2298 16.468 12.3258L24.28 15.5518Z",
    fill: "url(#paint3_linear_5099_13485)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5099_13485",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.575 5.47365) rotate(74.152) scale(26.5944 27.3948)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#E869CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7257D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5099_13485",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.89628 12.8088) rotate(59.532) scale(2.54186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B91D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#670938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5099_13485",
    x1: 25.936,
    y1: 15.2598,
    x2: 16.06,
    y2: 7.58776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5099_13485",
    x1: 23.59,
    y1: 4.72176,
    x2: 18.976,
    y2: 14.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FB5937",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3E1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggy);
export default __webpack_public_path__ + "static/media/piggy.e1fcb953a163ce5ef097fe7245c766be.svg";
export { ForwardRef as ReactComponent };